import ConnectBank from "./ConnectBank";

export default ConnectBank;
export {
  AgreementBlock,
  AgreementBlockMessage,
  AgreementBlockTitle,
  AgreementCheckbox,
} from "./styles";
